import { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useEditor } from "@grapesjs/react";
import { toast } from "react-toastify";
import { Template, useGetPagesQuery } from "@/redux/reducer/pages.api";
import { PageTypes } from "@/App";
import { CustomCommands } from "@/shared/utils";
import { createPreviewCommands } from "./previewCommands";

export default function usePreviewLinks() {
  const editor = useEditor();
  const { id, type } = useParams<{ id: string; type: PageTypes }>();
  const { currentTemplate } = useGetPagesQuery(
    {},
    {
      selectFromResult: ({ data, ...rest }) => ({
        // @ts-ignore
        currentTemplate: (data?.[`${type}_templates`] || []).find(
          (template: Template) => template.id === id
        ) as Template,
        ...rest,
      }),
    }
  );
  const currentTemplateRef = useRef<Template | undefined>(currentTemplate);
  currentTemplateRef.current = currentTemplate;

  useEffect(() => {
    const liveButton = editor.Panels.getButton("options", "live-template");
    liveButton?.set('disable', !currentTemplate?.html_published_url)
  }, [currentTemplate]);

  useEffect(() => {
    const { openPreview, openLive } = createPreviewCommands({
      getTemplate: () => currentTemplateRef.current,
      open: (url) => window.open(url, "_blank"),
      notify: (message) => toast.error(message),
    });
    editor.Commands.add(CustomCommands.TEMPLATE_OPEN_PREVIEW, openPreview);
    editor.Commands.add(CustomCommands.TEMPLATE_OPEN_LIVE, openLive);
  }, []);
}
